module.exports = __webpack_public_path__ + "img/print-magnifying-glass.3a2fce8a.svg";